// extracted by mini-css-extract-plugin
export const container = "ShipFacilityModal-module--container--3GBxU";
export const leftSide = "ShipFacilityModal-module--left-side--3Vra2";
export const rightSide = "ShipFacilityModal-module--right-side--3Hbx3";
export const tabListBackground = "ShipFacilityModal-module--tab-list-background--1eW3q";
export const tabList = "ShipFacilityModal-module--tab-list--2ClD8";
export const panelFixHeight = "ShipFacilityModal-module--panel-fix-height--3eRg7";
export const bedroomsInfo = "ShipFacilityModal-module--bedrooms-info--3yIMb";
export const suitePlan = "ShipFacilityModal-module--suite-plan--1oFjF";
export const suiteFeatures = "ShipFacilityModal-module--suite-features--3ZYlM";
export const raqContainer = "ShipFacilityModal-module--raq-container--1mV9G";
export const raqCta = "ShipFacilityModal-module--raq-cta--35n9p";
export const price = "ShipFacilityModal-module--price--1DXR8";